/**
 * This has an error when it's put in @lipsurf/common. Perhaps because
 * firebase is a peer dependency? Currently the exact same file is shared
 * between lipsurf.com and extension.
 *
 * This has side effects... make sure to mark as so in package.json
 */
import firebase from "firebase/compat/app";
import { firebaseConfig } from "@lipsurf/common/fs-shared";
export const firebaseApp = firebase.initializeApp(firebaseConfig);